import { AlertTriangle, XCircle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

const Stat = ({ icon: Icon, label, value, tone, testId }) => (
  <div className={cn("flex items-center gap-2 rounded-lg border px-3 py-2 text-sm", tone)} data-testid={testId}><Icon className="h-4 w-4" /><span className="font-mono font-bold">{value}</span> {label}</div>
);

export const ImportPreview = ({ rows }) => {
  const ok = rows.filter((r) => r.ok);
  const warned = ok.filter((r) => r.warnings.length);
  const failed = rows.filter((r) => !r.ok);
  const shown = [...failed, ...warned, ...ok.filter((r) => !r.warnings.length)].slice(0, 400);
  return (
    <div data-testid="import-preview">
      <div className="mb-3 flex flex-wrap gap-2">
        <Stat icon={CheckCircle2} label="will import" value={ok.length} tone="border-emerald-200 bg-emerald-50 text-emerald-800" testId="preview-ok-count" />
        <Stat icon={AlertTriangle} label="with warnings (still imported)" value={warned.length} tone="border-amber-200 bg-amber-50 text-amber-800" testId="preview-warn-count" />
        <Stat icon={XCircle} label="will NOT import" value={failed.length} tone="border-rose-200 bg-rose-50 text-rose-800" testId="preview-fail-count" />
      </div>
      {rows.length > shown.length && <p className="mb-2 text-xs text-slate-500">Showing {shown.length} of {rows.length} rows – problem rows are listed first.</p>}
      <div className="max-h-[60vh] overflow-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full min-w-[900px] text-sm">
          <thead className="sticky top-0 bg-slate-50 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            <tr>{["Row", "Result", "Move Pro #", "Customer", "Date", "Pickup → Delivery", "Issues"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr>
          </thead>
          <tbody>
            {shown.map((r) => (
              <tr key={r.row} className={cn("border-t border-slate-100", !r.ok && "bg-rose-50/60", r.ok && r.warnings.length && "bg-amber-50/40")} data-testid={`preview-row-${r.row}`}>
                <td className="px-3 py-2 font-mono text-xs text-slate-500">{r.row}</td>
                <td className="px-3 py-2">{r.ok ? <span className="text-emerald-700">Import</span> : <span className="font-semibold text-rose-700">Skip</span>}</td>
                <td className="px-3 py-2 font-mono font-semibold">{r.data.job_number || "—"}</td>
                <td className="px-3 py-2">{r.data.customer_name || "—"}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.data.moving_date || "—"}</td>
                <td className="max-w-[260px] truncate px-3 py-2 text-slate-600">{r.data.pickup_address} → {r.data.delivery_address}</td>
                <td className="px-3 py-2 text-xs">
                  {r.errors.map((e, i) => <div key={i} className="text-rose-700">✕ {e}</div>)}
                  {r.warnings.map((w, i) => <div key={i} className="text-amber-700">⚠ {w}</div>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
